import React from 'react';
import { Grid } from '@mui/material';
import { tqlResultsEmptyStateStyles } from './tql-editor-helper';

export const TQLResultsEmptySate = (): React.JSX.Element => {
    return (
        <Grid sx={tqlResultsEmptyStateStyles.emptyStateContainer}>
            <Grid sx={tqlResultsEmptyStateStyles.emptyStateTitleText}>
                No Results
            </Grid>
            <Grid sx={tqlResultsEmptyStateStyles.emptyStateBodyText}>
                Run TQL to see your results.
            </Grid>
        </Grid>
    );
};
